import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useOnContentImpression = (onStart: () => void) => {
    useInstanceEffect((instance) => instance.onContentImpression(onStart), [onStart]);
};
